import React from 'react';
import { useTranslation } from 'react-i18next';
import DiscoveryFeatureCard from 'components/DiscoveryFeatureCard';
import useGroupChatSellSideDiscovery from '../../hooks/useGroupChatSellSideDiscovery';
import BannerWrapper from 'components/BannerWrapper';

import './GroupChatSellSideCard.styles.scss';

const GroupChatSellSideCard: React.FC = () => {
  const { showCard, onUnderstood, onGoToGroupChat } =
    useGroupChatSellSideDiscovery();

  const { t } = useTranslation();

  if (!showCard) return null;

  return (
    <BannerWrapper className="messaging__discovery-banner">
      <DiscoveryFeatureCard
        className="group-chat-sell-side-card "
        title={t('groupChatsAvailableTitle')}
        description="groupChatsAvailableDescription"
        primaryActionLabel={t('goToGroupChat')}
        onPrimaryAction={onGoToGroupChat}
        onUnderstood={onUnderstood}
      />
    </BannerWrapper>
  );
};

export default GroupChatSellSideCard;
